import { Section } from "@/components/ui/Section";
import { useState } from "react";

export default function Contact() {
  const [sent, setSent] = useState(false);
  return (
    <Section eyebrow="// Contact" title="Let's build something real." subtitle="Tell us about your business. We'll come back within one business day with a Brand Strength estimate and a 60-minute audit slot.">
      <div className="grid gap-10 md:grid-cols-2">
        <form
          onSubmit={(e) => { e.preventDefault(); setSent(true); }}
          className="panel p-8 space-y-5"
        >
          <Field label="Name" name="name" />
          <Field label="Work email" name="email" type="email" />
          <Field label="Company" name="company" />
          <Field label="Website" name="site" type="url" />
          <div>
            <label className="eyebrow">// What are you trying to solve?</label>
            <textarea rows={5} className="mt-2 w-full rounded-md border border-ink-700 bg-ink-900 px-4 py-3 text-silver-100 focus:border-brand-blue focus:outline-none" />
          </div>
          <button className="btn-primary w-full justify-center">Send it</button>
          {sent && <div className="chip">Received — we'll reply within 1 business day.</div>}
        </form>
        <div className="space-y-6">
          <div className="panel p-6">
            <div className="eyebrow">// Direct</div>
            <p className="mt-2 text-silver-100 font-display text-xl">hello@infinimarketing.com</p>
          </div>
          <div className="panel p-6">
            <div className="eyebrow">// Hours</div>
            <p className="mt-2 text-silver-200">Mon–Fri · 9:00–18:00</p>
          </div>
          <div className="panel-hi p-6">
            <div className="eyebrow">// Existing client?</div>
            <p className="mt-2 text-silver-100">Head to the <a className="text-brand-blue underline" href="/portal/login">Client Portal</a> to see your Spark progress, deliverables, and ROI.</p>
          </div>
        </div>
      </div>
    </Section>
  );
}

function Field({ label, name, type = "text" }: { label: string; name: string; type?: string }) {
  return (
    <div>
      <label htmlFor={name} className="eyebrow">// {label}</label>
      <input id={name} name={name} type={type} className="mt-2 w-full rounded-md border border-ink-700 bg-ink-900 px-4 py-3 text-silver-100 focus:border-brand-blue focus:outline-none" />
    </div>
  );
}
